import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ZingChart from 'zingchart-react';
import { getMeasurements } from '../../actions';

import './measurements.css';

class Measurements extends Component {
  state = {
    config: {
      type: 'line',
      'scale-x': {
        'min-value':0,
        "label": {
          "text": "secs",
        }
      },
      'scale-y': {
        'min-value':0,
        "label": {
          "text": "users",
        }
      },
      series: [{
        values: []
      }]
    }
  }

  componentWillMount = () => {
    this.props.getMeasurements();
  }

  componentWillReceiveProps = (nextProps) => {
  }

  mapTimes = (measurements) => {
    let nums = {};
    let times = [];

    let m = measurements.map(msmnt => msmnt.total_time);

    m.forEach(element => {
      if(nums[element] == null) nums[element] = 1;
      else nums[element]++;
    });

    Object.keys(nums).forEach(key => {
      times.push([key, nums[key]]);
    })

    // times = times.sort((a, b) => b[1] - a[1])

    this.setState({ config: {
      type: 'line',
      'scale-x': {
        'min-value':0,
        "label": {
          "text": "secs",
        }
      },
      'scale-y': {
        'min-value':0,
        "label": {
          "text": "users",
        }
      },
      series: [{
        values: times
      }]
    }})
  }

  selectMeasurementType = (evt) => {
    const type = evt.target.value;

    if(this.props.measurements){
      let measurements = this.props.measurements.filter(msmnt => msmnt.measurement_type === type);

      this.mapTimes(measurements);
    } else {
      console.log("error getting measurments");
    }
  }

  render() {
    return (
      <div >
        <select className="measurement_select" defaultValue="Select measurement type" onChange={this.selectMeasurementType}>
          <option> Select measurement type</option>
          <option value="phone"> Phone</option>
          <option value="body"> Body </option>
        </select>
        <ZingChart data={this.state.config}/>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    measurements: state.measurement.measurements
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getMeasurements },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Measurements);